import React, { useEffect, useState } from 'react'
import { Container, Row, Col } from "react-bootstrap";
import "./AboutMe.css"
import { FaGraduationCap } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { Link } from 'react-scroll';
import { useHighlight } from '../ContextProviders/HighlightContext';

const AboutMe = () => {

    const location = useLocation()
    const { toggleHighlight } = useHighlight();


    useEffect(() => {
        if (location.hash) {
            let elem = document.getElementById(location.hash.slice(1))
            if (elem) {
                elem.scrollIntoView({ behavior: "smooth" })
            }
        } else {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
        }
    }, [location,])


    return (
        <Container fluid >
            <Row>
                <Col>
                    <Container>
                        <h1 className='biography'> Biography</h1>
                        <p className='text-1'><strong>Hello, I'm Elo!</strong>

                        </p>
                        <p className='text-1'>
                            I am a senior software developer focused on delivering efficient and well-crafted solutions.
        My approach is systematic and detail-oriented, ensuring that
                            each project I undertake is executed with precision and a clear understanding of
                            the requirements.

                        </p>
                        <p className='text-1'>My academic background at the  <a className='a-link' href="https://www.frro.utn.edu.ar/" target='blank'>National Technological University</a> has
                            equipped me with a comprehensive set of skills that I continuously enhance.
                            By staying current with industry trends, I ensure that my work remains relevant and valuable.
                        </p>

                        <p className='text-1'>
                            If you're looking for a developer who can bring a thoughtful and practical approach to your project, I'm open to <Link to="home" smooth="true" duration={550} onClick={toggleHighlight}>
                                <a className='contact' href='/#home'>new opportunities</a>
                            </Link>.</p>

                        <h2 className='interests'>Interests</h2>
                        <Container className='intertests-container'>
                            <ul>
                                <li>Data Engineering </li>
                                <li>DevOps</li>
                                <li>Game Engines</li>
                                <li>Parallel Programming</li>
                                <li>Embedded Systems</li>
                            </ul>
                        </Container>

                        <h2 className='interests'>Education</h2>
                        <Container className='intertests-container'>
                            <Container className='uvp-list'>
                                <ul class="list-unstyled">
                                    <FaGraduationCap /> TECHNICAL PROGRAMMING DEGREE (University Level), 2021 - 2023
                                    <p className='education-p'> · National Technological University, Argentina.</p>
                                </ul>

                            </Container>

                        </Container>

                    </Container>
                </Col>
            </Row>
        </Container>
    )
}

export default AboutMe
